import { useEffect, useState } from "react";
import axios from "../../../../requests/axios";
import routes from "../../../../requests/routes";
import Loader from "../../../../layouts/loader/Loader";
import UserCard from "../userCard/UserCard";
import classes from "./UserReviews.module.scss";

export const UserReviews = ({ record }) => {
  const wishlist = record.reviews;
  const [adminReviews, setAdminReviews] = useState([]);
  const [loader, setLoader] = useState(true);

  async function getReviews() {
    try {
      const response = await axios.get(routes.getReviews);
      setAdminReviews(response.data.reviews);
      setLoader(false);
    } catch (err) {}
  }
  useEffect(() => {
    getReviews();
  }, []);

  const wishIdSet = new Set(wishlist.map(String));
  const filteredReviews = adminReviews.filter((p) =>
    wishIdSet.has(String(p._id ?? p.id))
  );

  return (
    <>
      <div className={classes.cards}>
        {loader ? (
          <Loader color={"#F46444"} />
        ) : filteredReviews.length > 0 ? (
          filteredReviews.map((wl, index) => <UserCard key={index} user={wl} />)
        ) : (
          <>No Data</>
        )}
      </div>
    </>
  );
};
